import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import { verifyCheckoutSession } from '../stripe/checkout';

const StoreSuccess = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [orderDetails, setOrderDetails] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Auth-gating is handled by <ProtectedRoute> at the route level.
  useEffect(() => {
    window.scrollTo(0, 0);

    const verify = async () => {
      // Get session ID from URL
      const sessionId = searchParams.get('session_id');

      if (!sessionId) {
        setError('No session ID found');
        setLoading(false);
        return;
      }

      try {
        // Verify the session with your backend
        const sessionData = await verifyCheckoutSession(sessionId);
        setOrderDetails(sessionData);
      } catch (err) {
        console.error('Error verifying session:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    verify();
  }, [searchParams]);

  if (loading) {
    return (
      <Layout>
        <section id="wrapper">
          <div className="inner" style={{ paddingTop: "40px", textAlign: "center" }}>
            <h2 className="major">Processing your order...</h2>
            <p>Please wait while we confirm your payment.</p>
          </div>
        </section>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <section id="wrapper">
          <div className="inner" style={{ paddingTop: "40px" }}>
            <h2 className="major" style={{ textAlign: "center", color: "#ff5555" }}>
              Payment Verification Error
            </h2>
            <div style={{
              maxWidth: "600px",
              margin: "30px auto",
              padding: "30px",
              backgroundColor: "rgba(255, 85, 85, 0.1)",
              borderRadius: "10px",
              border: "1px solid rgba(255, 85, 85, 0.3)",
              textAlign: "center"
            }}>
              <p style={{ fontSize: "1.1em", marginBottom: "20px" }}>{error}</p>
              <p style={{ opacity: "0.9" }}>
                Don't worry - if payment was processed, we'll send you a confirmation email.
              </p>
              <button
                onClick={() => navigate('/store')}
                style={{
                  marginTop: "20px",
                  padding: "12px 30px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#FF5722",
                  color: "#fff",
                  fontSize: "1em",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
              >
                Back to Store
              </button>
            </div>
          </div>
        </section>
      </Layout>
    );
  }

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: "40px" }}>
          <h2 className="major" style={{ textAlign: "center", color: "#4CAF50" }}>
            ✓ Payment Successful!
          </h2>
          
          <div style={{
            maxWidth: "700px",
            margin: "30px auto",
            padding: "40px",
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            borderRadius: "12px",
            border: "2px solid rgba(76, 175, 80, 0.3)"
          }}>
            <p style={{ 
              fontSize: "1.2em", 
              textAlign: "center", 
              marginBottom: "30px",
              fontWeight: "600"
            }}>
              Thank you for your purchase!
            </p>

            {orderDetails && (
              <div style={{
                backgroundColor: "rgba(27, 31, 34, 0.85)",
                padding: "25px",
                borderRadius: "8px",
                marginBottom: "30px"
              }}>
                <h3 style={{ marginTop: "0", marginBottom: "20px", color: "#FF5722" }}>
                  Order Details
                </h3>
                <div style={{ lineHeight: "2" }}>
                  <p><strong>Item:</strong> {orderDetails.itemName}</p>
                  <p><strong>Amount:</strong> ${orderDetails.amount}</p>
                  <p><strong>Email:</strong> {orderDetails.email}</p>
                  {orderDetails.promoCode && (
                    <p><strong>Premium Access Code:</strong> <span style={{ color: "#4CAF50", fontWeight: "bold" }}>{orderDetails.promoCode}</span></p>
                  )}
                </div>
              </div>
            )}

            <div style={{
              padding: "20px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              borderRadius: "8px",
              marginBottom: "30px"
            }}>
              <h4 style={{ marginTop: "0", marginBottom: "15px" }}>What's Next?</h4>
              <ul style={{ margin: "0", paddingLeft: "20px", lineHeight: "1.8" }}>
                <li>You'll receive a confirmation email shortly</li>
                <li>We'll contact you to schedule your session</li>
                <li>Check your email for your Premium Access code</li>
                <li>Redeem your code in the Range Drills app</li>
              </ul>
            </div>

            <div style={{ textAlign: "center" }}>
              <button
                onClick={() => navigate('/portal')}
                style={{
                  padding: "12px 30px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "#FF5722",
                  color: "#fff",
                  fontSize: "1em",
                  fontWeight: "bold",
                  cursor: "pointer",
                  marginRight: "15px"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#e64a19";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#FF5722";
                }}
              >
                Go to Portal
              </button>
              <button
                onClick={() => navigate('/store')}
                style={{
                  padding: "12px 30px",
                  borderRadius: "8px",
                  border: "1px solid rgba(255, 255, 255, 0.3)",
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  color: "#fff",
                  fontSize: "1em",
                  fontWeight: "bold",
                  cursor: "pointer"
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                }}
              >
                Back to Store
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default StoreSuccess;
